import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { CiMail } from "react-icons/ci";
import { SendMail } from "../../lib/api";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import Spinner from "../../components/ui/loader";
import LocationPin from ".././../lib/animation/locationPin.json";

function ContactUs() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { register, handleSubmit, reset } = useForm();

  const handleMapLoad = () => {
    setIsLoading(false);
  };

  const mutateSendMail = useMutation({
    onMutate: () => {
      setIsSubmitting(true);
    },
    mutationFn: (data) => {
      const response = SendMail(data);
      return response;
    },
    onSuccess: () => {
      toast.success("Successfully send mail");
    },
    onError: () => {
      toast.error("Send Mail Failed!");
    },
    onSettled: () => {
      reset();
      setIsSubmitting(false);
    },
  });

  const onSubmit = (data) => {
    const formData = {
      ...data,
      subject: "Contact Us",
    };
    mutateSendMail.mutate(formData);
  };
  return (
    <div className="mx-auto max-w-[1024px] p-4">
      <div className="mb-4">
        <div className="mb-6 max-w-3xl text-center sm:text-center md:mx-auto md:mb-12">
          <p className="text-base poppins_semibold uppercase tracking-wide">
            Contact Us
          </p>
          <h2 className="mb-4 poppins_bold tracking-tight text-3xl sm:text-5xl">
            Get in Touch With us
          </h2>
        </div>
        <div className="relative w-full overflow-hidden aspect-w-16 aspect-h-9">
          {isLoading && (
            <div className="absolute inset-0 flex justify-center items-center bg-gray-200">
              <Lottie
                animationData={LocationPin}
                loop={true}
                autoplay={true}
                speed={1.5}
              />
            </div>
          )}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.595948817367!2d76.29699577416287!3d9.967535373594291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080d238dd96fe3%3A0xc40e72d8890950c9!2sSpider%20Techno%20Soft%20Pvt.%20Ltd!5e0!3m2!1sen!2sin!4v1741951876908!5m2!1sen!2sin"
            width="1200"
            height="350"
            title="googlemap"
            className="border-none"
            allowfullscreen=""
            onLoad={handleMapLoad}
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="h-full">
          <p className="poppins_medium mt-3 mb-12 text-md min-[480px]:text-lg">
            Feel free to contact us if you have any questions or need further
            assistance.
          </p>
          <ul className="mb-6 md:mb-0">
            <li className="flex">
              <div className="flex h-10 w-10 items-center justify-center rounded bg-[#f6892f] text-gray-50">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-6 w-6"
                >
                  <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                  <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
                </svg>
              </div>
              <div className="poppins_medium ml-2 mb-4 text-sm min-[480px]:text-lg">
                <h3 className="mb-2 font-medium leading-6 text-[#f6892f]">
                  Our Address
                </h3>
                <p className="w-52 sm:w-64">
                  FIRST FLOOR, BUILDING, Junction, D D Milestone, Sahodaran
                  Ayyappan Rd, Kadavanthra Junction, Kadavanthra, Ernakulam,
                  Kerala 682020
                </p>
              </div>
            </li>
            <li className="flex">
              <div className="flex h-10 w-10 items-center justify-center rounded bg-[#f6892f] text-gray-50">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-6 w-6"
                >
                  <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"></path>
                  <path d="M15 7a2 2 0 0 1 2 2"></path>
                  <path d="M15 3a6 6 0 0 1 6 6"></path>
                </svg>
              </div>
              <div className="poppins_medium ml-2 mb-4 text-sm min-[480px]:text-lg">
                <h3 className="mb-2 font-medium leading-6 text-[#f6892f]">
                  Contact
                </h3>
                <p>Mobile: +91 77369 04688</p>
                <p>Mobile: +91 99958 01797</p>
              </div>
            </li>
            <li className="flex">
              <div className="flex h-10 w-10 items-center justify-center rounded bg-[#f6892f] text-gray-50">
                <CiMail size="25px" />
              </div>
              <div className="poppins_medium ml-2 mb-4 text-sm min-[480px]:text-lg">
                <h3 className="mb-2 font-medium leading-6 text-[#f6892f]">
                  Email
                </h3>
                <p>mobipos@spidertechnosoft.com</p>
              </div>
            </li>
          </ul>
        </div>
        <div className="card h-fit max-w-6xl" id="form">
          <h2 className="mb-4 text-2xl poppins_bold ">Ready to Get Started?</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-6 poppins_medium">
              <div className="mx-0 mb-1 sm:mb-4">
                <div className="mx-0 mb-1 sm:mb-4">
                  <label
                    htmlFor="firstName"
                    className="pb-1 text-xs uppercase tracking-wider"
                  ></label>
                  <input
                    type="text"
                    id="firstName"
                    autoComplete="given-name"
                    placeholder="Your name"
                    {...register("firstName")}
                    className="mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 shadow-md sm:mb-0"
                    name="firstName"
                    required
                  />
                </div>
                <div className="mx-0 mb-1 sm:mb-4">
                  <label
                    htmlFor="email"
                    className="pb-1 text-xs uppercase tracking-wider"
                  ></label>
                  <input
                    type="email"
                    id="email"
                    autoComplete="email"
                    {...register("email")}
                    placeholder="Your email address"
                    className="mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 shadow-md sm:mb-0"
                    name="email"
                    required
                  />
                </div>
              </div>
              <div className="mx-0 mb-1 sm:mb-4">
                <label
                  htmlFor="textarea"
                  className="pb-1 text-xs uppercase tracking-wider"
                ></label>
                <textarea
                  id="textarea"
                  name="textarea"
                  cols="30"
                  rows="5"
                  {...register("message")}
                  required
                  placeholder="Write your message..."
                  className="mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 shadow-md sm:mb-0"
                ></textarea>
              </div>
            </div>
            <div className="text-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className="poppins_semibold w-full bg-[#f6892f] text-white px-6 py-3 font-xl rounded-md sm:mb-0 ml-0"
              >
                {isSubmitting ? <Spinner /> : "Send Message"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
